<template>
  <AsyncComp />
  <Toaster />
</template>

<script>
import { defineAsyncComponent, h } from "vue/dist/vue.esm-bundler.js";
import axios from "axios";

const BlankLoaderComponent = {
  render() {
    return h(
      "div",
      {
        role: "status",
        "aria-live": "polite",
        style: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "#fff",
          zIndex: 10000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      },
      [
        h("span", {
          style: {
            position: "absolute",
            width: "1px",
            height: "1px",
            overflow: "hidden",
            clip: "rect(0,0,0,0)",
          },
          innerHTML: "Chargement…",
        }),
        h("div", {
          "aria-hidden": "true",
          style: {
            width: "40px",
            height: "40px",
            border: "4px solid #f3f3f3",
            borderRadius: "50%",
            borderTop: "4px solid #555",
            animation: "pageLoaderSpin 1s linear infinite",
          },
        }),
      ],
    );
  },
};

// Cart
import cartprocess from "@/components/cart/Process.vue";
import carttable from "@/components/cart/Table.vue";
import carttotals from "@/components/cart/Totals.vue";
import cartcoupon from "@/components/cart/Coupon.vue";
import cartextrasell from "@/components/cart/ExtraSell.vue";
import cartfreeshippingprogression from "@/components/cart/FreeShippingProgression.vue";
import cartminicart from "@/components/cart/MiniCart.vue";
import carttablechoicelist from "@/components/cart/table/ChoiceList.vue";
import carttableupselllist from "@/components/cart/table/UpsellList.vue";
import carttableupselldiff from "@/components/cart/table/UpsellDiff.vue";
import carttitle from "@/components/cart/Title.vue";
import ordersummary from "@/components/cart/OrderSummary.vue";
// Category
import categorylongdescription from "@/components/category/LongDescription.vue";
import categoryshortdescription from "@/components/category/ShortDescription.vue";
import categorysubcategories from "@/components/category/SubCategories.vue";
import categorylongname from "@/components/category/LongName.vue";
import categoryname from "@/components/category/Name.vue";
import categoryicon from "@/components/category/Image.vue";
import categoryimage from "@/components/category/Image.vue";
// Checkout
import checkoutbuttoncanceloneclick from "@/components/checkout/ButtonCancelOneClick.vue";
import checkoutcontactform from "@/components/checkout/ContactForm.vue";
import checkoutpaymentform from "@/components/checkout/PaymentForm.vue";
import checkoutorderrecap from "@/components/checkout/OrderRecap.vue";
import paymentrecurrenceswitch from "@/components/checkout/PaymentRecurrenceSwitch.vue";
import checkoutextrasell from "@/components/checkout/Extrasell.vue";
import checkoutthankyourichcontent from "@/components/checkout/ThankYouRichContent.vue";
import checkoutbuttonprocessorder from "@/components/checkout/ButtonProcessOrder.vue";
import checkoutconfirmationtitle from "@/components/checkout/ConfirmationTitle.vue";
import checkoutorderrecaptitle from "@/components/checkout/OrderRecapTitle.vue";
import checkoutcontacttitle from "@/components/checkout/ContactTitle.vue";
import checkoutpaymentmethodtitle from "@/components/checkout/PaymentMethodTitle.vue";
import checkoutconfirmationgifts from "@/components/checkout/ConfirmationGifts.vue";
import checkoutlinkredirects from "@/components/checkout/LinkRedirects.vue";
import orderpageretry from "@/components/checkout/OrderPageRetry.vue";
import checkoutlinkredirect from "@/components/checkout/LinkRedirect.vue";
// Product
import productargument1 from "@/components/product/Argument1.vue";
import productargument2 from "@/components/product/Argument2.vue";
import productargument3 from "@/components/product/Argument3.vue";
import productargument4 from "@/components/product/Argument4.vue";
import productargument5 from "@/components/product/Argument5.vue";
import productargument from "@/components/product/ProductArgument.vue";
import productcategories from "@/components/product/Categories.vue";
import productbclchoices from "@/components/product/ChoicesBcl.vue";
import productnbclchoices from "@/components/product/ChoicesNbcl.vue";
import productdescription from "@/components/product/ProductContent.vue";
import productshortdescription from "@/components/product/ProductContent.vue";
import productextraproducts from "@/components/product/ExtraProducts.vue";
import productimages from "@/components/product/Images.vue";
import productlongname from "@/components/product/LongName.vue";
import productname from "@/components/product/Name.vue";
import productfeaturedname from "@/components/product/FeaturedProductName.vue";
import productratings from "@/components/product/Ratings.vue";
import productvisualstock from "@/components/product/VisualStock.vue";
import productconfigurablechoices from "@/components/product/ProductConfigurableChoices.vue";
import productprogressbar from "@/components/product/ProgressBar.vue";
import customizeproduct from "@/components/product/CustomizeProduct.vue";
// Choice
import choicefreelabel from "@/components/choice/FreeLabel.vue";
import choicevanguarddescription from "@/components/choice/VanguardDescription.vue";
import choicevanguardlabel from "@/components/choice/VanguardLabel.vue";
import choiceupselldescription from "@/components/choice/UpsellDescription.vue";
import choiceprice from "@/components/choice/Price.vue";

// Waiting pages
import waitingogone from "@/components/waiting/Payment.vue";
import waitingdoubleoptin from "@/components/waiting/DoubleOptin.vue";
import waitingpayment from "@/components/waiting/Payment.vue";

import addtocart from "@/components/AddToCart.vue";
import cookiedeclaration from "@/components/CookieDeclaration.vue";
import breadcrumbs from "@/components/Breadcrumbs.vue";
import debug from "@/components/Debug.vue";
import loader from "@/components/Loader.vue";
import mainmenu from "@/components/Menu.vue";
import productlist from "@/components/productlist/ProductList.vue";
import seo from "@/components/Seo.vue";
import tracking from "@/components/Tracking.vue";
import orderpageprocess from "@/components/OrderPageProcess.vue";
import logo from "@/components/Logo.vue";
import Toaster from "@/components/Toaster.vue";

import mounted from "@/services/mounted.js";
import Utils from "@/services/utils";
import { localizeOrderPageSectionTitles } from "@/services/orderPageSectionTitles";
import {
  isConfirmationPagePath,
  upgradeConfirmationPageTemplate,
} from "@/services/confirmationTemplateUpgrade";

export default {
  name: "App",
  components: {
    Toaster,
    AsyncComp: defineAsyncComponent({
      loadingComponent: BlankLoaderComponent,
      delay: 0,
      loader: () => {
        const indexFile = document
          .getElementById("app")
          .hasAttribute("data-index-file")
          ? document.getElementById("app").getAttribute("data-index-file")
          : null;

        const getComponents = () => {
          return {
            cartprocess,
            carttable,
            carttotals,
            cartcoupon,
            cartextrasell,
            cartfreeshippingprogression,
            cartminicart,
            carttablechoicelist,
            carttableupselldiff,
            carttitle,
            ordersummary,

            categorylongdescription,
            categoryshortdescription,
            categorysubcategories,
            categorylongname,
            categoryname,
            categoryicon,
            categoryimage,

            checkoutbuttoncanceloneclick,
            checkoutcontactform,
            checkoutpaymentform,
            checkoutorderrecap,
            paymentrecurrenceswitch,
            checkoutextrasell,
            checkoutthankyourichcontent,
            checkoutbuttonprocessorder,
            checkoutconfirmationtitle,
            checkoutorderrecaptitle,
            checkoutcontacttitle,
            checkoutpaymentmethodtitle,
            checkoutconfirmationgifts,
            checkoutlinkredirects,
            orderpageretry,

            productcategories,
            productbclchoices,
            productnbclchoices,
            productextraproducts,
            productimages,
            productargument1,
            productargument,
            productargument2,
            productargument3,
            productargument4,
            productargument5,
            productratings,
            productdescription,
            productshortdescription,
            productvisualstock,
            productlongname,
            productname,
            productfeaturedname,
            productconfigurablechoices,
            productprogressbar,
            customizeproduct,

            carttableupselllist,
            choicefreelabel,
            choicevanguarddescription,
            choicevanguardlabel,
            choiceprice,
            choiceupselldescription,

            waitingogone,
            waitingdoubleoptin,
            waitingpayment,

            addtocart,
            breadcrumbs,
            cookiedeclaration,
            debug,
            loader,
            mainmenu,
            productlist,
            seo,
            tracking,
            orderpageprocess,
            logo,
          };
        };

        const getTemplate = (pathName) => {
          if (pathName.indexOf("previewapp") !== -1) {
            return pathName.replace("previewapp", "previewindex");
          }
          if (indexFile) {
            return indexFile;
          }

          if (pathName === "/") {
            return `/pages/home/index.html`;
          } else {
            return `/pages/${pathName.replace(/^\/|\/$/g, "")}/index.html`;
          }
        };

        return new Promise((resolve, reject) => {
          const searchURL = new URL(window.location);

          if (process.env.VUE_APP_SENTRY_ENV !== "production") {
            console.log(process.env);
          }

          axios
            .get(getTemplate(searchURL.pathname))
            .then((response) => {
              let template = response.data;
              if (isConfirmationPagePath(searchURL.pathname)) {
                template = upgradeConfirmationPageTemplate(template);
              }
              resolve({
                components: getComponents(),
                template,
                computed: {
                  isRetryMode() {
                    return new URLSearchParams(window.location.search).has(
                      "retry",
                    );
                  },
                },
                async mounted() {
                  this.$i18n.locale = window.globalConfig?.lang || "fr";
                  this.$nextTick(() => {
                    localizeOrderPageSectionTitles();
                    document.dispatchEvent(new Event("vue-app-mounted"));
                  });

                  if (this.isRetryMode) {
                    const style = document.createElement("style");
                    style.textContent =
                      ".container::before { display: none !important; }";
                    document.head.appendChild(style);
                  }
                },
              });
            })
            .catch(() => {
              axios
                .get("/pages/notfound/index.html")
                .then((notFoundResponse) => {
                  resolve({
                    components: getComponents(),
                    template: notFoundResponse.data,
                    async mounted() {
                      this.$i18n.locale = window.globalConfig?.lang || "fr";
                      this.$nextTick(() => {
                        localizeOrderPageSectionTitles();
                        document.dispatchEvent(new Event("vue-app-mounted"));
                      });
                    },
                  });
                })
                .catch((err) => reject(err));
            });
        });
      },
    }),
  },
};
</script>
